import { StyleSpecification } from 'maplibre-gl'

const hereApiKey = process.env.REACT_HERE_API_KEY || ''

// HERE Maps v3 raster tiles — {z}/{x}/{y} is standard XYZ, no subdomain expansion needed
function hereV3Style(hereStyle: string): StyleSpecification {
  return {
    version: 8,
    sources: {
      here: {
        type: 'raster',
        tiles: [
          `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?apiKey=${hereApiKey}&style=${hereStyle}`,
        ],
        tileSize: 256,
        attribution: '© HERE',
        maxzoom: 20,
      },
    },
    layers: [{ id: 'here-base', type: 'raster', source: 'here' }],
  }
}

export type MapLibreLayerType = 'vector' | 'satellite' | 'terrain'

export function getMapLibreStyle(
  layer: MapLibreLayerType,
): string | StyleSpecification {
  switch (layer) {
    case 'satellite':
      return hereV3Style('explore.satellite.day')
    case 'terrain':
      return hereV3Style('topo.day')
    case 'vector':
    default:
      return hereV3Style('explore.day')
  }
}
